/**
 * 首页分类按钮
 */
import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { productMobx, mallMobx } from 'mobx/mall'
import { handleEleScrollTo, scrollToPoint } from '@utils'
import { classNames } from '@dt/fe-utils'
import './index.scss'

interface IProps {
  mode?: 'horizontal' | 'vertical';
  variant?: 'classicBig' | 'classicList';
  selectedNo?: string;
  onSelectCategory?: (categoryNo: string) => void;
}

const CategoryBtns: FC<IProps> = ({ mode = 'horizontal', variant = 'classicBig', selectedNo, onSelectCategory }) => {
  const { categories } = mallMobx
  const isVertical = mode === 'vertical'
  const isClassicList = variant === 'classicList'
  const [selectNo, setSelectNo] = useState<string>(mallMobx.selectCategoryNo || '')
  const [isFixed, setFixed] = useState<boolean>(false)
  const [btnsOffsetLeft, setBtnsOffsetLeft] = useState<number[]>([])
  useEffect(() => {
    if (isVertical) return
    setFixedFun(mallMobx.mallScrollTop)
  }, [mallMobx.mallScrollTop, isVertical])
  useEffect(() => {
    setSelectNo(isVertical ? selectedNo || '' : mallMobx.selectCategoryNo || '')
  }, [isVertical, mallMobx.selectCategoryNo, selectedNo])
  useEffect(() => {
    if (!isVertical) return
    const wrapper = document.querySelector('.mall-category-btns-container.vertical .mall-category-btns-wrapper') as HTMLElement
    const activeItem = wrapper?.querySelector('.mall-category-btn-item.active') as HTMLElement
    if (!wrapper || !activeItem) return
    if (activeItem.offsetTop < wrapper.scrollTop) {
      wrapper.scrollTop = activeItem.offsetTop
    } else if (activeItem.offsetTop + activeItem.offsetHeight > wrapper.scrollTop + wrapper.clientHeight) {
      wrapper.scrollTop = activeItem.offsetTop + activeItem.offsetHeight - wrapper.clientHeight
    }
  }, [isVertical, selectNo])
  useEffect(() => {
    if (isVertical) return
    const listDom = document.querySelectorAll('.mall-category-btn-item')
    let offsetList = []
    let width = 16
    listDom.forEach((item: HTMLElement) => {
      offsetList.push(item.offsetLeft - 16)
      width += item.offsetWidth + 32
    })
    setBtnsOffsetLeft([...offsetList])
    try {
      const wrapDom = document.querySelector('.mall-category-btn-list') as HTMLElement
      wrapDom.style.width = width + 'px'
    } catch (error) {}
  }, [categories, isVertical])
  // 选择分类
  const handleSelectCategory = (category?: ICategory | string) => {
    if (isVertical) {
      const categoryNo = typeof category === 'string' ? '' : category?.no || ''
      const scrollContainer = document.querySelector(`.mall-product-list-content.${isClassicList ? 'classic-list' : 'classic-big'}`) as HTMLElement
      const categoryAnchor = document.querySelector(`#mall-category-item-${categoryNo}`) as HTMLElement
      setSelectNo(categoryNo)
      onSelectCategory?.(categoryNo)
      if (!scrollContainer) return
      if (!categoryNo) {
        scrollContainer.scrollTo({ top: 0, behavior: 'auto' })
        return
      }
      if (categoryAnchor) {
        const top = categoryAnchor.getBoundingClientRect().top - scrollContainer.getBoundingClientRect().top + scrollContainer.scrollTop - 8
        scrollContainer.scrollTo({ top, behavior: 'auto' })
      }
      return
    }
    mallMobx.selectCategory(category)
    if (typeof category === 'string') {
      setSelectNo('')
    } else {
      setSelectNo(category.no)
    }
    const menuListContent = document.querySelector('.mall-product-template') as any
    let offsetTop = menuListContent?.offsetTop || 0
    if (offsetTop >= 48) {
      offsetTop = offsetTop - 48
    }
    setFixedFun(offsetTop)
    handleEleScrollTo?.({ selector: 'ion-content.mall-container', y: offsetTop })
  }
  // 控制当前点击的按钮居中
  const setScrollToCenter = (index: number) => {
    if (isVertical) return
    const centerLeft = window.innerWidth / 3
    const offsetLeft = btnsOffsetLeft[index]
    try {
      const wrapperDom = document.querySelector('.mall-category-btns-wrapper') as any
      scrollToPoint(wrapperDom, { x: offsetLeft - centerLeft, duration: 200 })
    } catch (error) {}
  }
  // 控制分类栏吸附
  const setFixedFun = (offsetTop: number) => {
    if (isVertical) return
    if (offsetTop >= 56) {
      setFixed(true)
    } else {
      setFixed(false)
    }
  }

  return (
    <div className={classNames('mall-category-btns-container', mode, { fixed: isFixed, 'classic-list': isClassicList })}>
      <div className='mall-category-btns-wrapper'>
        <div className='mall-category-btn-list'>
          {
            !isVertical && (
              <div
                className={classNames('mall-category-btn-item', { active: !selectNo })}
                // style={{ background: colorMap[0] }}
                onClick={() => {
                  handleSelectCategory('')
                  setScrollToCenter(0)
                }}
              >{i18n.t('mall.allProduct')}
              </div>
            )
          }
          {
            categories.map((item, index) => {
              return (
                <div
                  key={item.no}
                  className={classNames('mall-category-btn-item', { active: selectNo === item.no })}
                  onClick={(e) => {
                    handleSelectCategory(item)
                    setScrollToCenter(index + 1)
                  }}
                >{item.name}
                </div>
              )
            })
          }
        </div>
      </div>
    </div>
  )
}

export default observer(CategoryBtns)
